import React from 'react';
interface EmotionTagProps {
  emoji: string;
  label: string;
  selected?: boolean;
  onClick: () => void;
}
export function EmotionTag({
  emoji,
  label,
  selected,
  onClick
}: EmotionTagProps) {
  return <button onClick={onClick} className={`px-4 py-2.5 rounded-full font-medium transition-all focus:outline-none focus:ring-2 focus:ring-sky-400 ${selected ? 'bg-sky-400 text-white shadow-md scale-105' : 'bg-white text-slate-700 border-2 border-slate-200 hover:border-sky-300 hover:bg-sky-50'}`} data-id="element-79">
      <span className="mr-2" data-id="element-80">{emoji}</span>
      {label}
    </button>;
}